import { useState } from 'react';
import './Photo.scss';

export const Photo = ({
  src,
  title,
  onPhotoClick,
  onMetadataClick,
  isSelected,
  onSelectChange,
  downloadUrl,
}: {
  src: string;
  title: string;
  onPhotoClick: () => void;
  onMetadataClick: () => void;
  isSelected?: boolean;
  onSelectChange?: (selected: boolean) => void;
  downloadUrl?: string;
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleImageError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  const handlePhotoClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onPhotoClick();
  };

  const handleMetadataClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onMetadataClick();
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    onSelectChange?.(e.target.checked);
  };

  return (
    <div className="pf-photo">
      <div className="pf-photo-image" onClick={handlePhotoClick}>
        {isLoading && (
          <div className="pf-photo-loader">
            <div className="pf-photo-spinner"></div>
          </div>
        )}
        {hasError && (
          <div className="pf-photo-error">
            <span>Ошибка загрузки</span>
          </div>
        )}
        <img
          src={src}
          alt={title}
          onLoad={handleImageLoad}
          onError={handleImageError}
          style={{ display: isLoading ? 'none' : 'block' }}
        />
      </div>

      {/* Чекбокс для выбора */}
      <div className="pf-photo-checkbox">
        <input
          type="checkbox"
          checked={isSelected || false}
          onChange={handleCheckboxChange}
          onClick={e => e.stopPropagation()}
        />
      </div>

      {/* Иконка метаданных */}
      <div className="pf-photo-metadata-icon" onClick={handleMetadataClick}>
        <i className="fa fa-info-circle" aria-hidden="true"></i>
      </div>

      {/* Кнопка скачивания */}
      {downloadUrl && (
        <a
          href={downloadUrl}
          download={title}
          target="_blank"
          rel="noopener noreferrer"
          className="pf-photo-download-icon"
          onClick={e => e.stopPropagation()}
        >
          <i className="fa fa-download" aria-hidden="true"></i>
        </a>
      )}

      <div className="pf-photo-title">
        <span>{title}</span>
      </div>
    </div>
  );
};
